package devxertech.com.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.TextOverflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.textOverflow
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleDown
import com.varabyte.kobweb.silk.components.icons.fa.FaDownload
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.style.DropdownStyleDark
import devxertech.com.style.DropdownStyleLight
import devxertech.com.theme.LocalColorMode
import devxertech.com.theme.Palette
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants.FONT_FAMILY
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul

@Composable
private fun DropdownCore(
    isDownloadButton: Boolean,
    width: CSSLengthOrPercentageNumericValue,
    height: CSSLengthOrPercentageNumericValue,
    maxHeight: CSSLengthOrPercentageNumericValue,
    isPagination: Boolean,
    disableButKeepStyle: Boolean,
    disabled: Boolean,
    id: String,
    listWidth: CSSLengthOrPercentageNumericValue,
    selectedLabel: String,
    selectedIndex: Int = -1, // ✅ NEW PARAM
    items: List<Triple<String, Boolean, Boolean>>,
    onItemClick: (Int) -> Unit,
    accessibleLabel: String = "",
) {
    val colorMode = LocalColorMode.current
    val sitePalette = colorMode.toSitePalette()

    Box(
        modifier = Modifier.width(width).id(id).margin(topBottom = 0.px)
            .classNames(if (disabled) "disabled" else "dropdown")
            .height(height).borderRadius(5.px)
            .color(if (disabled && !disableButKeepStyle) sitePalette.textFieldSupportiveTextColor.rgb else sitePalette.textFieldTextColor.rgb)
            .border(
                width = if (disabled && !disableButKeepStyle) 0.px else 1.px,
                style = LineStyle.Solid,
                color = if (isDownloadButton) sitePalette.primary.rgb else sitePalette.commonSecondaryButtonColor.rgb
            )
            .backgroundColor(if (disabled && !disableButKeepStyle) sitePalette.textFieldBorderColorDisabled.rgb else sitePalette.modalBackgroundColor.rgb)
            .cursor(Cursor.Pointer)
    ) {
        // Header
        Button(attrs = Modifier.fillMaxSize().styleModifier {
            property("background", "transparent")
            property("border", "0")
            property("padding", "0")
            property("border-radius", "inherit")
            property("color", "inherit")
        }.toAttrs {
            attr("type", "button")
            attr("data-bs-toggle", "dropdown")
            attr("aria-expanded", "false")
            if (disabled) attr("disabled", "")
            if (id.isNotBlank()) {
                attr("id", "$id-toggle")
                attr("aria-controls", "$id-options")
            }
            if (accessibleLabel.isNotBlank()) attr("aria-label", "$accessibleLabel: $selectedLabel")
        }) {
        Row(
            modifier = Modifier.fillMaxSize()
                .padding(leftRight = if (isPagination) 10.px else 15.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            SpanText(
                text = selectedLabel,
                modifier = Modifier.maxWidth(100.percent).whiteSpace(WhiteSpace.NoWrap)
                    .textOverflow(TextOverflow.Ellipsis).fontSize(12.px).overflow(Overflow.Hidden)
                    .color(
                        if (isDownloadButton) sitePalette.primary.rgb
                        else if (disabled && !disableButKeepStyle) sitePalette.textFieldSupportiveTextColor.rgb
                        else sitePalette.textFieldTextColor.rgb
                    ).styleModifier { property("font-family", FONT_FAMILY) }
            )
            if (isDownloadButton) {
                FaDownload(Modifier.color(sitePalette.primary.rgb))
            } else {
                FaAngleDown(Modifier.color(sitePalette.textFieldTextColor.rgb), size = IconSize.XXS)
            }
        }
        }

        // Items
        Ul(
            attrs = Modifier.width(listWidth).classNames("dropdown-menu")
                .backgroundColor(sitePalette.modalBackgroundColor.rgb).maxHeight(maxHeight)
                .overflow(Overflow.Auto).zIndex(999).attrsModifier {
                    if (id.isNotBlank()) attr("id", "$id-options")
                    if (accessibleLabel.isNotBlank()) attr("aria-label", accessibleLabel)
                    style { property("min-width", listWidth.toString()) }
                }.toAttrs()
        ) {
            val colorMode1 = ColorMode.current
            val modifier1 =
                if (colorMode1 == ColorMode.LIGHT) DropdownStyleLight else DropdownStyleDark

            var hoveredIndex by remember { mutableStateOf(-1) }

            items.forEachIndexed { index, (label, isDisabled, isDanger) ->
                val isHovered = hoveredIndex == index
                val isSelected = selectedIndex == index && hoveredIndex == -1

                val bgColor = when {
                    isHovered -> sitePalette.primary.rgb
                    isSelected -> sitePalette.primary.rgb
                    else -> sitePalette.modalBackgroundColor.rgb
                }

                val textColor = when {
                    isHovered || isSelected -> Palette.White.rgbLight
                    isDanger -> sitePalette.textErrorColor.rgb
                    isDisabled -> sitePalette.textFieldSupportiveTextColor.rgb
                    else -> sitePalette.textFieldTextColor.rgb
                }

                Li {
                    Button(
                        attrs = modifier1.toModifier()
                            .classNames("dropdown-item")
                            .attrsModifier {
                                attr("type", "button")
                                if (isDisabled) attr("disabled", "")
                                attr("aria-pressed", (selectedIndex == index).toString())
                            }
                            .backgroundColor(bgColor)
                            .thenIf(isDisabled) { Modifier.pointerEvents(PointerEvents.None) }
                            .onMouseEnter { hoveredIndex = index }     // track current hover
                            .onMouseLeave { hoveredIndex = -1 }        // reset hover
                            .onClick {
                                if (!isDisabled) onItemClick(index)
                            }
                            .styleModifier {
                                property("border", "0")
                                property("text-align", "left")
                                property("font-family", FONT_FAMILY)
                                property("transition", "background-color 0.15s ease, color 0.15s ease")
                            }
                            .toAttrs()
                    ) {
                        SpanText(
                            text = label,
                            modifier = Modifier
                                .fillMaxWidth()
                                .color(textColor)
                                .fontSize(12.px)
                                .whiteSpace(WhiteSpace.PreWrap)
                                .styleModifier { property("font-family", FONT_FAMILY) }
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun CommonDropdown(
    isDownloadButton: Boolean = false,
    unClickable: List<String> = emptyList(),
    width: CSSLengthOrPercentageNumericValue = 100.percent,
    data: List<String>,
    onSelect: (String) -> Unit,
    selectedItem: String,
    height: CSSLengthOrPercentageNumericValue = 39.px,
    maxHeight: CSSLengthOrPercentageNumericValue = 500.px,
    isPagination: Boolean = false,
    disableButKeepStyle: Boolean = false,
    disabled: Boolean = false,
    id: String = "",
    listWidth: CSSLengthOrPercentageNumericValue = width,
    accessibleLabel: String = "",
) {
    val selectedIndex = data.indexOf(selectedItem)
    DropdownCore(
        isDownloadButton = isDownloadButton,
        accessibleLabel = accessibleLabel,
        width = width,
        height = height,
        maxHeight = maxHeight,
        isPagination = isPagination,
        disableButKeepStyle = disableButKeepStyle,
        disabled = disabled,
        id = id,
        listWidth = listWidth,
        selectedLabel = selectedItem,
        selectedIndex = selectedIndex,
        items = data.map {
            Triple(
                it,
                it in unClickable,
                "Delete User" in it
            )
        },
        onItemClick = { onSelect(data[it]) }
    )
}
